import { useEffect, useState, useRef } from "react";
import { ApiEndpoints } from "../../store/type/API-Endpoints";
import { getEmptySitesAPI, getGroups, getInactiveSitesAPI } from "../../Api Methods/Api";
import { Await } from "react-router-dom";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import classes from '../OfflineSites/offlineSites.module.css'
import DataManager from "../../hooks/DataManager";
import SearchBar from "../SearchView/Search/SearchBar";
import DevicesList from "../../components/GridList/DevicesList";
import { useDispatch, useSelector } from "react-redux";
import Stats2 from "../../components/UI/Stats/Stats2";
import { Button } from "primereact/button";
import ActiveSitesSearchbar from "./activeSitesSearchbar";
import { serviceActions } from "../../store/service-Slice";
import mixpanel from "mixpanel-browser";

const ActiveSites = () => {

    const cachedSites = useSelector(state => state.service.ActiveSitesTableData);
    const [activeSites, setActiveSites] = useState(cachedSites);
    console.log(cachedSites)

    //const [activeSites, setActiveSites] = useState([])
    const [isLoading, setIsLoading] = useState(() => {
      return !cachedSites || cachedSites.length === 0;
    });  
    const [isLoadingStats, setIsLoadingStats] = useState(true)
    const [searchTerm, setSearchTerm] = useState("")
    const [filteredData, setFilteredData] = useState(cachedSites)
    const dataManager = new DataManager();

    const [totalPages, setTotalPages] = useState([])
    const [resultCount, setResultCount] = useState(0)
    const [totalDevices, setTotalDevices] = useState([])
    const [pageOffset, setPageOffset] = useState(0)
    const dispatch = useDispatch();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const [pageFetchedIndex, setPageFetchedIndex] = useState(1)
    const [pageSize, setPageSize] = useState(dataManager.getItem('pageSize'))
    const [update, setUpdate] = useState(0)
    const [showMassSettings, setShowMassSettings] = useState(false)

    const [selectedFilter, setSelectedFilter] = useState("")
    const [sortBy, setSortBy] = useState([])
    const [page, setPage] = useState(1);
    const [visibleDevices, setVisibleDevices] = useState([]);
    
    const [groups, setGroups] = useState([])
    const [selectedGroupFilter, setSelectedGroupFilter] = useState([])
    const [portalSiteNameFilter, setPortalSiteNameFilter] = useState("")
    const [includes, setIncludes] = useState(true)

    const [online, setOnline] = useState(0)
    const [offline, setOffline] = useState(0)
    const [deviceTag, setDeviceTag] = useState(null)
    const [deviceType, setDeviceType] = useState(0)
    const [groupName, setGroupName] = useState(null)
    const [noTag, setNoTag] = useState(0)

    const [submit, setSubmit] = useState(0)

    const [showLoadMore, setShowLoadMore] = useState(true)

    const prevBody = useRef();

    const apiData = {
        token,
        client
    }

  //   const HandleLoadMore = () => {
  //     setIsLoading(true);
  
  //     const getActiveSites = async () => {
  //         let body = {
  //             "active": 1,
  //             "pageSize": 100,
  //             "pageOffset": activeSites.length, // skip already loaded rows
  //             "online": online,
  //             "offline": offline,
  //             "deviceTag": deviceTag,
  //             "deviceType": deviceType,
  //             "groupName": groupName,
  //             "noTag": noTag
  //         };
  
  //         const response = await getInactiveSitesAPI(apiData, body, dispatch);
  
  //         // Merge new data with existing
  //         setActiveSites(prevSites => [...prevSites, ...response.data[1]]);
  //         setFilteredData(prevSites => [...prevSites, ...response.data[1]]);
  
  //         // Optional: if fewer than pageSize returned, disable the button
  //         if (response.data[1].length < body.pageSize) {
  //             // e.g. setHasMore(false)
  //             setShowLoadMore(false)
  //         }
  
  //         setIsLoading(false);
  //     };
  
  //     getActiveSites();
  // };


    const getSites = async (body) => {
        const response = await getInactiveSitesAPI(apiData, body, dispatch)
        console.log(response)
        setActiveSites(response.data[1])
        setResultCount(response.data[0][0].totalCount)
        setFilteredData(response.data[1])
        setTotalPages(Math.ceil(response.data[0][0].totalCount / pageSize));
        dispatch(serviceActions.setActiveSitesTableData(response.data[1]));
        console.log(response.data[1])
        setIsLoading(false)
        setIsLoadingStats(false)
    }

    const GetGroups = async () => {
        try {
            const listOptions = await getGroups(apiData, dispatch);
            console.log(listOptions);
            setGroups(listOptions || []);
        } catch (error) {
            console.error('Failed to fetch groups:', error);
            setGroups([]);
        }
    }

    useEffect(() => {
      GetGroups();
      mixpanel.track("Active sites tab visited", {
        user: localStorage.getItem('email')
      });

    }, [])

    useEffect(() => {
      setIsLoading(true)
      const offset = pageSize * (pageFetchedIndex -1); 
      setPageOffset(offset);
  
      console.log("Offset:", offset);
  
        let body = {
            "active": 1,
            "pageSize": pageSize,
            "pageOffset": offset,
            "online": online,
            "offline": offline, 
            "deviceTag": deviceTag,
            "deviceType": deviceType,
            "groupName": groupName,
            "noTag": noTag,
            "searchTerm": searchTerm
        }

        console.log(body)

        getSites(body)

        const timer = setTimeout(() => {
          if (prevBody.current && (JSON.stringify(body) !== JSON.stringify(prevBody.current))) {
              mixpanel.track("Active sites search performed", {
                  user: localStorage.getItem('email'),
                  body: body
              });
          }
          prevBody.current = body;
        }, 2000);
        return () => clearTimeout(timer);
    }, [submit, pageSize, pageFetchedIndex, online, offline, deviceTag, deviceType, groupName, noTag])

    useEffect(() => {
      const delay = setTimeout(() => {
        // Trigger a refresh via submit or whatever you use
        setSubmit(prev => !prev); 
      }, 400); // 300–500ms debounce recommended
    
      return () => clearTimeout(delay);
    }, [searchTerm]);

    return (
      <>
      
      <div style={{ width: "100%"}}>
                <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
                    <div style={{ width:"350px" }} >
                        <Stats2
                            title={"Active sites"}
                            value={resultCount}
                            isLoadingStats={isLoadingStats}
                            isStatic={true}
                        />
                    </div>
                </div>
            </div>

            <div className={classes.searchContainer}>

                <ActiveSitesSearchbar
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    showFilterButton={true}
                    groups={groups}
                    online={online}
                    setOnline={setOnline}
                    offline={offline}
                    setOffline={setOffline}
                    deviceTag={deviceTag}
                    setDeviceTag={setDeviceTag}
                    deviceType={deviceType}
                    setDeviceType={setDeviceType}
                    groupName={groupName}
                    setGroupName={setGroupName}
                    submit={submit}
                    setSubmit={setSubmit}
                    noTag={noTag}
                    setNoTag={setNoTag}
                    style={{
                        padding: "10px", 
                        width: "300px",    
                        fontSize: "14px",  
                        boxSizing: "border-box", 
                        borderRadius: "4px",
                    }}/>

                {searchTerm !== "" && <div>
                    <p>{filteredData.length} results</p>
                </div>}
              </div>


        <Await resolve={activeSites}>
          {(loadedActiveSites) => {
            return (
              <>
              <div style={{ width: "100%"}}>
              {isLoading ? (
                <div style={{ display: "flex", width: "100%" }}>
                  <DeviceLoadingGrid
                    CardCount={
                      20
                    }
                  />
                </div>
              ) : (
                <>
              
                <DevicesList
                  devices={loadedActiveSites}
                  filtering={""}
                  hideControls={false}
                  totalPages={totalPages}
                  setTotalPages={setTotalPages}
                  pageFetchedIndex={pageFetchedIndex}
                  setPageFetchedIndex={setPageFetchedIndex}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  totalDevices={resultCount}
                  setTotalDevices={setTotalDevices}
                  groupMode={false}
                  update={update}
                  setUpdate={setUpdate}
                  offlineOnly={false}
                  isSortable={true}
                  showMassSelect={true}
                  showMassSettings={showMassSettings}
                  setShowMassSettings={setShowMassSettings}
                  
                />
                </>
                
              )}
            </div>
            </>
            )
          }}
        </Await>
        </>
      )
}

export default ActiveSites;